import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Download } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const DocumentoPreviewModal = ({ 
  open, 
  onClose, 
  documento 
}) => {
  if (!documento) return null;

  const esImagen = documento.url?.match(/\.(jpg|jpeg|png|gif|webp)$/i);
  const esPDF = documento.url?.match(/\.pdf$/i);
  const urlCompleta = documento.url?.startsWith('http') ? documento.url : `${BACKEND_URL}${documento.url}`;

  const handleDescargar = () => {
    const link = document.createElement('a');
    link.href = urlCompleta;
    link.download = documento.nombre || 'documento';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh]">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-[#0E3A53] flex items-center justify-between">
            <span>{documento.nombre}</span>
            <button
              onClick={handleDescargar}
              className="flex items-center gap-2 px-3 py-1.5 bg-[#1AA1D8] text-white rounded-lg hover:bg-[#0E3A53] transition-colors text-sm"
            >
              <Download className="w-4 h-4" />
              Descargar
            </button>
          </DialogTitle>
        </DialogHeader>
        
        <div className="mt-4 overflow-auto max-h-[70vh]">
          {esImagen && (
            <img 
              src={urlCompleta} 
              alt={documento.nombre} 
              className="max-w-full h-auto mx-auto rounded-lg"
            />
          )}
          
          {esPDF && (
            <iframe
              src={urlCompleta}
              title={documento.nombre}
              className="w-full h-[65vh] rounded-lg border"
            />
          )}
          
          {!esImagen && !esPDF && (
            <div className="text-center py-12 text-gray-500">
              <p>Vista previa no disponible para este tipo de archivo.</p>
              <button
                onClick={handleDescargar}
                className="mt-4 px-4 py-2 bg-[#1AA1D8] text-white rounded-lg hover:bg-[#0E3A53]"
              >
                Descargar archivo
              </button>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DocumentoPreviewModal;
